module.exports = __webpack_public_path__ + "img/gao1.e53ab865.png";